export function showLegacyHost(_visible: boolean): void {
  const root = document.getElementById('root');
  if (root) root.hidden = false;
}
